export interface GuestChatStorage {
    chatId: string;
    name: string;
    email: string;
}

const STORAGE_KEY = 'stiftselskab_guest_chat';

export function loadGuestChat(): GuestChatStorage | null {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const parsed = JSON.parse(raw) as Partial<GuestChatStorage>;
        if (typeof parsed.chatId === 'string') {
            return {
                chatId: parsed.chatId,
                name: typeof parsed.name === 'string' ? parsed.name : '',
                email: typeof parsed.email === 'string' ? parsed.email : '',
            };
        }

        return null;
    } catch {
        return null;
    }
}

export function saveGuestChat(session: GuestChatStorage): void {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearGuestChat(): void {
    window.localStorage.removeItem(STORAGE_KEY);
}
